<p-dialog
  [(visible)]="dialogVisible"
  (visibleChange)="visibleChange.emit($event)"
  [style]="{width: '90vw'}"
  [draggable]="false"
  [resizable]="true"
  [modal]="true"
  header="{{'select.asset' | transloco}}"
>
  <div class="flex justify-content-between pt-4 pb-3">
    <div class="flex">
      <span class="p-float-label p-input-icon-left">
          <i class="pi pi-search"></i>
          <input
            [(ngModel)]="currentFilters.alias"
            (keyup.enter)="applyFilters()"
            type="text"
            id="alias"
            pInputText
          >
          <label for="alias">{{'attribute.alias' | transloco}}</label>
      </span>
      <span class="p-float-label p-input-icon-left ml-2">
          <i class="pi pi-search"></i>
          <input
            [(ngModel)]="currentFilters.description"
            (keyup.enter)="applyFilters()"
            type="text"
            id="description"
            pInputText
          >
          <label for="description">{{'attribute.description' | transloco}}</label>
      </span>
      <span class="p-float-label ml-2 w-16rem">
        <p-multiSelect
          [(ngModel)]="currentFilters.representationNames"
          [styleClass]="'w-full'"
          [options]="representations"
          [filter]="true"
          optionLabel="value"
          optionValue="value"
          inputId="representation"
          display="chip"
          appendTo="body"
        ></p-multiSelect>
        <label>{{'model.assetRepresentation' | transloco}}</label>
      </span>
    </div>
    <div>
      <button
        [label]="'common.search' | transloco"
        (click)="applyFilters()"
        pButton
        icon="pi pi-search"
        iconPos="right"
      ></button>
    </div>
  </div>

  <p-table
    [(selection)]="selectedAsset"
    [(first)]="first"
    [(rows)]="rows"
    [value]="assets"
    [totalRecords]="totalAssets"
    [lazy]="true"
    (onLazyLoad)="onAssetPageChange($event)"
    [paginator]="true"
    [rowsPerPageOptions]="[10,25,50]"
    [breakpoint]="'DATATABLE_BREAKPOINT' | appConfig"
    [autoLayout]="true"
    [sortField]="DEFAULT_SORT_FIELD"
    [sortOrder]="DEFAULT_SORT_ORDER"
    responsiveLayout="stack"
    styleClass="p-datatable-striped"
  >
    <ng-template pTemplate="header">
      <tr>
        <th class="selection-column-width"></th>
        <th pSortableColumn="alias">
          {{'attribute.alias' | transloco}}
          <p-sortIcon field="alias"></p-sortIcon>
        </th>
        <th pSortableColumn="description">
          {{'attribute.description' | transloco}}
          <p-sortIcon field="description"></p-sortIcon>
        </th>
        <th pSortableColumn="assetRepresentation.name">
          {{'model.assetRepresentation' | transloco}}
          <p-sortIcon field="assetRepresentation.name"></p-sortIcon>
        </th>
        <th pSortableColumn="organization.name">
          {{'model.organization' | transloco}}
          <p-sortIcon field="organization.name"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-asset>
      <ng-component *ngIf="!hasBeenOpened || loadingAssets then skeletonRow else dataRow"></ng-component>
      <ng-template #dataRow>
        <tr>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'common.select' | transloco}}</span>
            <p-tableRadioButton [value]="asset"></p-tableRadioButton>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'attribute.alias' | transloco}}</span>
            <a [href]="'/assets/' + asset.uuid + '/details'" target="_blank">{{asset.alias}}</a>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'attribute.description' | transloco}}</span>
            <p class="text-right md:text-left">{{asset.description}}</p>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'model.assetRepresentation' | transloco}}</span>
            <p class="text-right md:text-left">{{asset.assetRepresentation ? asset.assetRepresentation.name : ''}}</p>
          </td>
          <td class="h-3rem py-0">
            <span class="p-column-title bold">{{'model.organization' | transloco}}</span>
            <p class="text-right md:text-left">{{asset.organization ? asset.organization.name : ''}}</p>
          </td>
        </tr>
      </ng-template>
      <ng-template #skeletonRow>
        <tr>
          <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
          <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
          <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
          <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
          <td class="h-3rem py-0"><p-skeleton height="1em"></p-skeleton></td>
        </tr>
      </ng-template>
    </ng-template>
  </p-table>

  <div class="flex justify-content-end py-3">
    <button
      *ngFor="let actionButton of actionButtons"
      [label]="actionButton.label | transloco"
      (click)="actionButton.action(selectedAsset)"
      [disabled]="!selectedAsset"
      [icon]="actionButton.icon"
      pButton
      class="mr-2"
      iconPos="right"
    ></button>
  </div>

</p-dialog>
